module.exports = __webpack_public_path__ + "static/img/course.0926e59d.jpg";